import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ade92130"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-stores__body" }
const _hoisted_2 = { class: "uf-stores__info" }
const _hoisted_3 = { class: "uf-stores__item-name" }
const _hoisted_4 = { class: "uf-stores__item-label van-ellipsis" }
const _hoisted_5 = {
  key: 1,
  style: {"color":"#fff"}
}
const _hoisted_6 = { class: "popover-inner" }
const _hoisted_7 = { class: "uf-button" }
const _hoisted_8 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!
  const _component_uf_stores = _resolveComponent("uf-stores")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_uf_form_item, {
      title: _ctx.options.title,
      required: _ctx.options.is_checked == '1',
      readonly: _ctx.disabled
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, _mergeProps({
          placeholder: _ctx.isEventDetail ? '-' : '请选择',
          modelValue: _ctx.fieldValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fieldValue) = $event)),
          readonly: "",
          disabled: _ctx.disabled
        }, _ctx.$attrs, {
          "is-link": _ctx.options.stores_arr ? true : !_ctx.disabled,
          onClick: _ctx.onClick
        }), null, 16, ["placeholder", "modelValue", "disabled", "is-link", "onClick"])
      ]),
      _: 1
    }, 8, ["title", "required", "readonly"]),
    _createVNode(_component_uf_stores, {
      show: _ctx.storesShow,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storesShow) = $event)),
      multiple: !_ctx.options.is_radio,
      onConfirm: _ctx.onConfirm
    }, null, 8, ["show", "multiple", "onConfirm"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showCheckedList,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showCheckedList) = $event)),
      position: "right",
      style: { height: '100%', width: '100%' },
      onOpened: _ctx.opened
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_nav_bar, {
            title: "已选客户机构",
            "left-text": "返回",
            "left-arrow": "",
            onClickLeft: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCheckedList = false))
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.stores_arr, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    class: "active",
                    clickable: "",
                    center: "",
                    key: item.id
                  }, _createSlots({
                    icon: _withCtx(() => [
                      _createVNode(_component_van_checkbox, {
                        modelValue: _ctx.showCheckedList,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showCheckedList) = $event)),
                        style: {"margin-right":"10px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(item.stores_name), 1)
                    ]),
                    label: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        (item.place_true_names)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(item.place_true_names), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock("i", _hoisted_5, " "))
                      ]),
                      _createElementVNode("div", {
                        class: "uf-stores__item-label uf-stores__item-label-hidden",
                        ref_for: true,
                        ref: el => _ctx.addCheckedPlaceRef(el, index)
                      }, _toDisplayString(item.place_true_names), 513)
                    ]),
                    _: 2
                  }, [
                    (_ctx.checkedPlacePopover[index])
                      ? {
                          name: "right-icon",
                          fn: _withCtx(() => [
                            _createVNode(_component_van_popover, {
                              show: item.showPopover,
                              "onUpdate:show": ($event: any) => ((item.showPopover) = $event),
                              placement: "bottom-end"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_van_icon, {
                                  name: "info",
                                  color: "#3d6eeb",
                                  size: "24"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(item.place_true_names), 1)
                              ]),
                              _: 2
                            }, 1032, ["show", "onUpdate:show"])
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_van_button, {
                class: "btn",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCheckedList = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onOpened"])
  ], 64))
}